{
    "name": "rentals-mfe",
    "version": "5.6.1",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:dev": "ng serve --configuration=development",
        "start:prod": "ng serve --configuration=production",
        "start:android": "ng serve --configuration=android",
        "start:android-http": "ng serve --configuration=android-http",
        "build": "ng build",
        "build:dev": "ng build --configuration=development",
        "build:prod": "ng build --configuration=production",
        "watch": "ng build --watch --configuration development",
        "test": "jest",
        "test:coverage": "jest --coverage",
        "test:watch": "jest --watch",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix",
        "cert:generate": "mkdir -p ./tls && npx mkcert create-cert --cert ./tls/localhost.rentals.ram.dev.syniotec.com-cert.pem --key ./tls/localhost.rentals.ram.dev.syniotec.com-key.pem --domains localhost.rentals.ram.dev.syniotec.com 127.0.0.1 ::1",
        "cert:generate:android": "./scripts/generate-android-cert.sh",
        "prepare": "husky"
    },
    "private": true,
    "dependencies": {
        "@ag-grid-community/locale": "^34.1.0",
        "@angular/animations": "19.2.14",
        "@angular/cdk": "19.2.19",
        "@angular/common": "19.2.14",
        "@angular/compiler": "19.2.14",
        "@angular/core": "19.2.14",
        "@angular/forms": "19.2.14",
        "@angular/google-maps": "19.2.19",
        "@angular/material": "19.2.19",
        "@angular/platform-browser": "19.2.14",
        "@angular/platform-browser-dynamic": "19.2.14",
        "@angular/router": "19.2.14",
        "@ngneat/svg-icon": "7.1.6",
        "@ngrx/component-store": "19.2.1",
        "@ngrx/effects": "^19.2.1",
        "@ngrx/operators": "^19.2.1",
        "@ngrx/signals": "^19.2.1",
        "@ngrx/store": "^19.2.1",
        "@ngx-translate/core": "^17.0.0",
        "@swimlane/ngx-charts": "^20.5.0",
        "@sharemactechhub/frontend-library": "19.0.144",
        "@syniotec-techhub/assets": "1.21.1",
        "@syniotec-techhub/common": "19.26.1",
        "@syniotec-techhub/core": "19.24.6",
        "@syniotec-techhub/ui": "19.42.0",
        "ag-grid-angular": "^34.1.0",
        "ag-grid-community": "^34.1.0",
        "ag-grid-enterprise": "^34.1.0",
        "d3": "^7.9.0",
        "es-module-shims": "^1.10.1",
        "lodash": "^4.17.23",
        "lodash-es": "^4.17.23",
        "moment": "^2.30.1",
        "moment-timezone": "^0.5.48",
        "ngrx-store-localstorage": "^19.0.0",
        "ngx-cookie-service": "^19.1.0",
        "ngx-infinite-scroll": "19.0.0",
        "ngx-mask": "19.0.6",
        "ngx-permissions": "^19.0.0",
        "rxjs": "~7.8.0",
        "socket.io-client": "^4.8.1",
        "tslib": "^2.8.1",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-architects/native-federation": "19.0.23",
        "@angular-devkit/architect": "0.1901.9",
        "@angular-devkit/build-angular": "19.2.15",
        "@angular/build": "19.2.15",
        "@angular/cli": "19.2.15",
        "@angular/compiler-cli": "19.2.14",
        "@commitlint/cli": "^20.1.0",
        "@commitlint/config-conventional": "^20.0.0",
        "@googlemaps/jest-mocks": "^2.21.4",
        "@happy-dom/jest-environment": "^17.0.0",
        "@ngrx/eslint-plugin": "^19.2.1",
        "@ngrx/schematics": "^19.2.1",
        "@smarttools/eslint-plugin-rxjs": "^1.0.18",
        "@types/d3": "^7.4.0",
        "@types/d3-scale": "^4.0.3",
        "@types/d3-selection": "^3.0.5",
        "@types/d3-shape": "^3.1.1",
        "@types/eslint-config-prettier": "^6.11.3",
        "@types/jest": "^29.5.14",
        "@types/lodash": "^4.17.20",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "20.14.9",
        "@typescript-eslint/eslint-plugin": "^8.23.0",
        "@typescript-eslint/parser": "^8.23.0",
        "angular-eslint": "19.0.2",
        "eslint": "^9.16.0",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-prettier": "^5.2.3",
        "eslint-plugin-unused-imports": "^4.1.4",
        "husky": "^9.1.4",
        "jest": "^29.7.0",
        "jest-junit": "^16.0.0",
        "jest-preset-angular": "^14.5.1",
        "lint-staged": "^15.2.7",
        "madge": "^7.0.0",
        "prettier": "3.7.4",
        "pretty-quick": "^4.2.2",
        "ts-node": "^10.9.2",
        "typescript": "~5.7.3",
        "typescript-eslint": "8.18.0"
    },
    "lint-staged": {
        "*.{ts,css,scss,html,json}": [
            "prettier --write"
        ],
        "*.{ts,tsx}": [
            "eslint"
        ]
    }
}
